export const PROJECT_LIST_ITEM_LINK_LINK = 'project-list-item-link-link'
export const PROJECT_LIST_ITEM_LINK_CONTAINER = 'project-list-item-link-container'
